// hooks/useGoToOrderWebstore.ts
// import { useRouter } from 'next/navigation';
import { useStoreItemSheet } from '@/app/[locale]/(order)/components/store-item/store-item-sheet-context';
import { useCartStore } from '@/store/cart/cart-store-provider';
import type { MenuItem } from '@/types/item';

export function useGoToOrderWebstore() {
  const { openSheet } = useStoreItemSheet();
  const setBranchId = useCartStore((state) => state.setBranchId);
  const clearCartIfDifferentStore = useCartStore(
    (state) => state.clearCartIfDifferentStore
  );
  return (
    pageId: string,
    slug: string,
    branchId: string,
    item: MenuItem,
    storeId: string,
    tag?: string
  ) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('ahafood.webstore_page_id', String(pageId));
      localStorage.setItem('ahafood.webstore_slug', String(slug));
      clearCartIfDifferentStore();
      setBranchId(branchId, storeId);
      openSheet(item, {
        storeId,
        pageId,
        slug,
        branchId,
        tag,
      });
    }
  };
}
